import React from 'react';
import { motion } from 'framer-motion';

const Button1 = ({ children, onClick, width }) => {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className={`px-6 py-2 text-white font-semibold rounded-full`}
      style={{
        width: width || 'auto',
        background: 'linear-gradient(102.87deg, #256EEF 46.28%, #00FFAE 166.92%)',
        borderRadius: '50px',
      }}
    >
      {children}
    </motion.button>
  );
};

export default Button1;
